export enum SubscriberSortBy {
  EMAIL = 'email',
  NAME = 'name',
  SUBSCRIPTION_SOURCE = 'subscription_source',
  SUBSCRIPTION_PLAN = 'subscription_plan',
  SUBSCRIPTION_LEVEL = 'subscription_level',
  SUBSCRIPTION_STATUS = 'subscription_status',
  JOINED_AT = 'joined_at'
}

export interface Subscriber {
  name: string | null
  username: string | null
  email: string
  image_url: string | null
  region: string | null
  country: string | null
  subscription_source: string
  subscription_plan: string | null
  subscription_level: string
  previous_subscription_level: string | null
  subscription_status: string | null
  joined_at: string | null
}

export interface SubscriberPage {
  total: number
  items: Subscriber[]
}

export interface SubscriberFilters {
  subscription_sources: string[]
  subscription_plans: string[]
  subscription_levels: string[]
  previous_subscription_levels: string[]
  subscription_statuses: string[]
  regions: Record<string, string[]>
}

export interface SubscriberLevelCounts {
  [level: string]: number
}
